import axios from 'axios'
import {config} from '../../../Constants'

const instance = axios.create({
  baseURL: config.url.API_BASE_URL
})

instance.interceptors.response.use(response => {
  return response;
}, (error) => {
  if (error.response.status === 404) {
    return { status: error.response.status };
  }
  return Promise.reject(error.response);
});

// -- Helper functions

function bearerAuth(token) {
  return `Bearer ${token}`
}
function list(token) {
  return instance.get('/api/cms/user/list/all/', {
    headers: { 'Authorization': bearerAuth(token) }
  })
}
function listByWebsite(websiteUuid, token) {
  return instance.get('/api/cms/user/list/', {
    params: {
      websiteUuid
    },
    headers: { 'Authorization': bearerAuth(token) }
  })
}
function get(uuid, token) {
  return instance.get(`/api/cms/user/${uuid}`, {
    headers: {'Content-Type': 'application/json', 'Authorization': bearerAuth(token) }
  })
}

function create(obj, token) {
  return instance.post('/api/cms/user', obj, {
    headers: {'Content-Type': 'application/json', 'Authorization': bearerAuth(token) }
  })
}

function update(uuid, obj, token) {
  return instance.put(`/api/cms/user/${uuid}`, obj, {
    headers: {'Content-Type': 'application/json', 'Authorization': bearerAuth(token) }
  })
}

function save(obj, token) {
  const {uuid} = obj;
  if (uuid.length > 0) 
    return update(uuid,obj, token);
  return create(obj, token);
}

function remove(uuid, token) {
  return instance.delete(`/api/cms/user/${uuid}`, {
    headers: { 'Authorization': bearerAuth(token) }
  })
}

// eslint-disable-next-line import/prefer-default-export
export const usersApi = {
  list,
  listByWebsite,
  get,
  create,
  update,
  save,
  remove
}